import { useCallback, useState } from 'react'
import { useLazyGetDropBySlugQuery } from '../../modules/listDrops/api'

const useFetchDropsChaptersBySlug = () => {
  const [fetchDropsQuery, { isLoading }] = useLazyGetDropBySlugQuery()

  const [drops, setDrops] = useState([])

  const fetchDrops = useCallback(
    async (slug: string) => {
      try {
        const { drops } = await fetchDropsQuery({ slug }).unwrap()
        setDrops([...drops].sort((a, b) => a.id - b.id))
      } catch (error) {
        console.error(error)
      }
    },
    [fetchDropsQuery],
  )

  return {
    isLoading,
    drops,
    fetchDrops,
  }
}

export default useFetchDropsChaptersBySlug
